import React, { useState, useEffect, useRef } from "react";
import { Link } from "react-router-dom/cjs/react-router-dom.min";
import {
  getIncentiveList,
  GetSalaryRegister,
  getSalarySlip,
} from "./Services/PayrollService";
import { GetMasterTypeData } from "../../../Services/Global-Services/GlobalServices";

const SalaryRegister = () => {
  const [employees, setEmployees] = useState([]);
  // const [filteredEmployees, setFilteredEmployees] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [deptFilter, setDeptFilter] = useState("");
  const [statusFilter, setStatusFilter] = useState("");
  const [selectedMonth, setSelectedMonth] = useState("");
  const [isLocked, setIsLocked] = useState(false);
  const [isDisbursed, setIsDisbursed] = useState(false);
  const [editModal, setEditModal] = useState({
    show: false,
    cellData: null,
    eid: "",
    field: "",
    value: 0,
  });
  const [showProcessSummery, setShowProcessSummery] = useState(false);
  const tableRef = useRef(null);
  let userDetails = JSON.parse(localStorage.getItem("User") || "{}");
  const [masterMonthList, setMasterMonthList] = useState([]);
  const [SalaryRegisterList, setSalaryRegisterList] = useState([]);

  useEffect(() => {
    GetMasterMonth();
    getSalaryRegisterList();
  }, []);

  async function getSalaryRegisterList() {
    let params = {
      ZoneId: 0,
      RegionId: 0,
    };
    try {
      let res = await GetSalaryRegister(params);
      console.log(res, "SalaryRegisterList-----------");
      setSalaryRegisterList(res?.Data);
    } catch (error) {
      console.error("Error fetching salary register list:", error);
    }
  }

  async function GetMasterMonth() {
    let params = {
      masterType: "formonth",
      allRecords: true,
      organisationId: userDetails?.OrgId,
    };

    try {
      const response = await GetMasterTypeData(params);
      console.log(response, "master month list-----");
      setMasterMonthList(response?.Data || []);

      const now = new Date();

      const month = String(now.getMonth() + 1).padStart(2, "0");
      const year = now.getFullYear();
      const latestMonth = response?.Data.filter((m) => m.Code === `${year}-${month}`);
      
      setSelectedMonth(latestMonth[0]?.Id);
    } catch (error) {
      console.error("Error fetching master month list:", error);
    }
  }

  // Sample data generation (same as original)
  // useEffect(() => {
  //   const DEPTS = [
  //     "Engineering",
  //     "Engineering",
  //     "Product",
  //     "Design",
  //     "Operations",
  //     "HR",
  //     "Finance",
  //     "Engineering",
  //     "Product",
  //     "Engineering",
  //   ];
  //   const ROLES = [
  //     "Sr. Engineer",
  //     "Engineer",
  //     "Product Manager",
  //     "UI Designer",
  //     "Ops Lead",
  //     "HR Manager",
  //     "Accountant",
  //     "Tech Lead",
  //     "Product Analyst",
  //     "DevOps Eng.",
  //   ];
  //   const MODES = [
  //     "account",
  //     "account",
  //     "account",
  //     "cash",
  //     "account",
  //     "account",
  //     "later",
  //     "account",
  //     "account",
  //     "account",
  //   ];
  //   const REGIMES = [
  //     "New",
  //     "New",
  //     "Old",
  //     "New",
  //     "Old",
  //     "Old",
  //     "New",
  //     "New",
  //     "New",
  //     "Old",
  //   ];

  //   const data = Array.from({ length: 48 }, (_, i) => {
  //     const mctc = 55000 + Math.round(Math.random() * 130000);
  //     const actc = mctc * 12;
  //     const basic = Math.round(mctc * 0.4);
  //     const hra = Math.round(basic * 0.5);
  //     const spec = Math.round(mctc - basic - hra - 5000);
  //     const bonus = 5000;
  //     const awd = 20 + Math.floor(Math.random() * 8);
  //     const lop = Math.max(0, 28 - awd);
  //     const r = awd / 28;
  //     const e_basic = Math.round(basic * r);
  //     const e_hra = Math.round(hra * r);
  //     const e_spec = Math.round(spec * r);
  //     const e_bonus = Math.round(bonus * r);
  //     const e_reimb = lop > 0 ? 0 : 3200;
  //     const ot = Math.random() > 0.7 ? Math.round(Math.random() * 3000) : 0;
  //     const tgross = e_basic + e_hra + e_spec + e_bonus + e_reimb + ot;
  //     const arrear = Math.random() > 0.8 ? Math.round(Math.random() * 8000) : 0;
  //     const incent =
  //       Math.random() > 0.75 ? Math.round(Math.random() * 15000) : 0;
  //     const varbl =
  //       Math.random() > 0.85 ? Math.round(Math.random() * 20000) : 0;
  //     const retain =
  //       Math.random() > 0.9 ? Math.round(Math.random() * 10000) : 0;
  //     const tadd = arrear + incent + varbl + retain;
  //     const pf_ee = Math.min(1800, Math.round(e_basic * 0.12));
  //     const esic_ee = tgross <= 21000 ? Math.round(tgross * 0.0075) : 0;
  //     const pt = 200;
  //     const tds = Math.max(0, Math.round(((tgross * 12 - 700000) * 0.15) / 12));
  //     const adv = Math.random() > 0.85 ? Math.round(Math.random() * 5000) : 0;
  //     const loan = Math.random() > 0.9 ? Math.round(Math.random() * 3000) : 0;
  //     const food = Math.random() > 0.7 ? 1500 : 0;
  //     const tded = pf_ee + esic_ee + pt + tds + adv + loan + food;
  //     const pf_er = pf_ee;
  //     const esic_er = esic_ee > 0 ? Math.round(tgross * 0.0325) : 0;
  //     const grat = Math.round(((basic / 26) * 15) / 12);
  //     const net = tgross + tadd - tded;

  //     return {
  //       i: i + 1,
  //       eid: `OG${String(54 + i).padStart(4, "0")}`,
  //       name:
  //         [
  //           "Ravindra Kumar",
  //           "Rohit Yadav",
  //           "Priya Sharma",
  //           "Ankit Verma",
  //           "Sneha Patel",
  //           "Vikram Singh",
  //           "Neha Gupta",
  //           "Arjun Mehta",
  //           "Deepa Rao",
  //           "Sanjay Kumar",
  //           "Pooja Agarwal",
  //           "Rahul Mishra",
  //           "Kavita Joshi",
  //           "Amit Tiwari",
  //           "Sunita Devi",
  //           "Ravi Shankar",
  //           "Ananya Nair",
  //           "Manish Pandey",
  //           "Divya Sinha",
  //           "Rajesh Yadav",
  //           "Meena Sharma",
  //           "Suresh Kumar",
  //           "Lakshmi Iyer",
  //           "Vikas Gupta",
  //           "Nisha Singh",
  //           "Arun Patel",
  //           "Rekha Verma",
  //           "Dinesh Chauhan",
  //           "Kavya Reddy",
  //           "Mohit Sharma",
  //           "Shweta Jain",
  //           "Ajay Kumar",
  //           "Preeti Singh",
  //           "Vinay Mishra",
  //           "Geeta Rani",
  //           "Harish Nair",
  //           "Smita Kulkarni",
  //           "Pankaj Srivastava",
  //           "Alok Tiwari",
  //           "Rashmi Sharma",
  //           "Sunil Kumar",
  //           "Pooja Mehta",
  //           "Vivek Rao",
  //           "Shikha Gupta",
  //           "Nikhil Joshi",
  //           "Archana Patel",
  //           "Raju Yadav",
  //           "Sonia Devi",
  //         ][i] || `Employee ${i + 1}`,
  //       dept: DEPTS[i % DEPTS.length],
  //       role: ROLES[i % ROLES.length],
  //       awd,
  //       lop,
  //       mctc,
  //       actc,
  //       basic,
  //       hra,
  //       spec,
  //       bonus,
  //       gs: basic + hra + spec + bonus,
  //       meal: 2200,
  //       fuel: 0,
  //       driver: 0,
  //       mobile: 500,
  //       internet: 500,
  //       books: 0,
  //       lta: 0,
  //       e_basic,
  //       e_hra,
  //       e_spec,
  //       e_bonus,
  //       e_reimb,
  //       ot,
  //       tgross,
  //       arrear,
  //       incent,
  //       varbl,
  //       retain,
  //       tadd,
  //       pf_ee,
  //       esic_ee,
  //       pt,
  //       tds,
  //       adv,
  //       loan,
  //       food,
  //       tded,
  //       pf_er,
  //       esic_er,
  //       grat,
  //       net,
  //       mode: MODES[i % MODES.length],
  //       regime: REGIMES[i % REGIMES.length],
  //       status: Math.random() > 0.15 ? "pending" : "paid",
  //       ovr: Math.random() > 0.8,
  //       overrides: {}, // to track overrides
  //     };
  //   });

  //   setEmployees(data);
  //   setFilteredEmployees(data);
  // }, []);

  // Filter function
  useEffect(() => {
    let result = [...employees];

    if (searchQuery) {
      const q = searchQuery.toLowerCase();
      result = result.filter((e) => e.name.toLowerCase().includes(q));
    }

    if (deptFilter) {
      result = result.filter((e) => e.dept === deptFilter);
    }

    if (statusFilter) {
      result = result.filter((e) => e.status === statusFilter);
    }

    setSalaryRegisterList(result);
  }, [employees, searchQuery, deptFilter, statusFilter]);

  const rup = (n) => {
    return n ? (
      `₹${n?.toLocaleString("en-IN", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      })}`
    ) : (
      <span className="zero">—</span>
    );
  };

  const calcTotals = (data) => {
    const keys = {
      awd: "t-awd",
      lop: "t-lop",
      mctc: "t-mctc",
      actc: "t-actc",
      basic: "t-basic",
      hra: "t-hra",
      spec: "t-spec",
      bonus: "t-bonus",
      gs: "t-gross-s",
      meal: "t-meal",
      mobile: "t-mobile",
      internet: "t-internet",
      e_basic: "t-e-basic",
      e_hra: "t-e-hra",
      e_spec: "t-e-spec",
      e_bonus: "t-e-bonus",
      e_reimb: "t-e-reimb",
      ot: "t-ot",
      tgross: "t-tgross",
      arrear: "t-arrear",
      incent: "t-incent",
      varbl: "t-variable",
      retain: "t-retain",
      tadd: "t-tadd",
      pf_ee: "t-pf-ee",
      esic_ee: "t-esic-ee",
      pt: "t-pt",
      tds: "t-tds",
      adv: "t-adv",
      loan: "t-loan",
      food: "t-food",
      tded: "t-tded",
      pf_er: "t-pf-er",
      esic_er: "t-esic-er",
      grat: "t-grat",
      net: "t-net",
    };

    Object.entries(keys).forEach(([k, id]) => {
      const el = document.getElementById(id);
      if (!el) return;
      const sum = data.reduce((a, e) => a + (e[k] || 0), 0);
      el.innerHTML = ["awd", "lop", "mctc"].includes(k)
        ? sum?.toFixed(2) || "—"
        : rup(sum);
    });
  };

  const updateSummaryCards = (data) => {
    const net = data.reduce((a, e) => a + (e.net || 0), 0);
    const pf_ee = data.reduce((a, e) => a + (e.pf_ee || 0), 0);
    const pf_er = data.reduce((a, e) => a + (e.pf_er || 0), 0);
    const esic_ee = data.reduce((a, e) => a + (e.esic_ee || 0), 0);
    const esic_er = data.reduce((a, e) => a + (e.esic_er || 0), 0);
    const tds = data.reduce((a, e) => a + (e.tds || 0), 0);
    const food = data.reduce((a, e) => a + (e.food || 0), 0);

    const byAccount = data.filter((e) => e.mode === "account").length;
    const byCash = data.filter((e) => e.mode === "cash").length;
    const byLater = data.filter((e) => e.mode === "later").length;

    document.getElementById("sc-emp").textContent = data.length;
    document.getElementById("sc-account").textContent = byAccount;
    document.getElementById("sc-cash").textContent = byCash;
    document.getElementById("sc-later").textContent = byLater;
    document.getElementById("sc-net").textContent =
      `₹${(net / 100000).toFixed(1)}L`;
    document.getElementById("sc-pf").textContent =
      `₹${Math.round((pf_ee + pf_er) / 1000)}K`;
    document.getElementById("sc-esic").textContent =
      `₹${Math.round((esic_ee + esic_er) / 1000)}K`;
    document.getElementById("sc-tds").textContent =
      `₹${Math.round(tds / 1000)}K`;
    document.getElementById("sc-food").textContent =
      `₹${Math.round(food / 1000)}K`;
  };

  // Re-calculate totals when filtered data changes
  useEffect(() => {
    if (SalaryRegisterList.length > 0) {
      setTimeout(() => {
        calcTotals(SalaryRegisterList);
        updateSummaryCards(SalaryRegisterList);
        document.getElementById("rowCount").textContent =
          `${SalaryRegisterList.length} employees`;
      }, 50);
    }
  }, [SalaryRegisterList]);

  const toggleGrp = (e) => {
    const chip = e.currentTarget;
    chip.classList.toggle("active");
    const grp = chip.dataset.grp;
    const show = chip.classList.contains("active");
    document.querySelectorAll("." + grp).forEach((el) => {
      el.style.display = show ? "" : "none";
    });
  };

  const openEdit = (cell, eid, field, value) => {
    if (isLocked) {
      alert("Cannot override in a locked period.");
      return;
    }
    setEditModal({
      show: true,
      cellData: cell,
      eid,
      field,
      value,
    });
  };

  const closeEdit = () => {
    setEditModal({ show: false, cellData: null, eid: "", field: "", value: 0 });
  };

  const applyEdit = () => {
    if (!editModal.cellData) return;

    const newValue = parseInt(document.getElementById("editInput").value) || 0;

    // Update cell visually
    editModal.cellData.innerHTML = `₹${newValue.toLocaleString("en-IN")} <span className="override-tag"><i className="fa-solid fa-pen-line"></i></span>`;
    editModal.cellData.style.background = "#fffbeb";

    // Update data in state (for totals)
    const updatedEmployees = employees.map((emp) => {
      if (emp.eid === editModal.eid) {
        const fieldKey = editModal.field.toLowerCase().replace(/\s+/g, "");
        // Simplified - you can extend this mapping as needed
        return { ...emp, [fieldKey]: newValue };
      }
      return emp;
    });

    setEmployees(updatedEmployees);
    closeEdit();
  };

  const setMode = (e, mode, eid) => {
    if (isLocked) return;

    const btnContainer = e.currentTarget.closest("div");
    btnContainer
      .querySelectorAll(".pay-mode-btn")
      .forEach((b) => b.classList.remove("sel"));
    e.currentTarget.classList.add("sel");

    // Update data
    setEmployees((prev) =>
      prev.map((emp) => (emp.eid === eid ? { ...emp, mode } : emp)),
    );
  };

  const markDisbursed = () => {
    if (isLocked) {
      alert("This period is locked. Unlock it first to mark as disbursed.");
      return;
    }

    const ok = window.confirm(
      "✅ Mark as Disbursed — February 2025\n\n" +
        "This confirms that all salaries have been paid out for this period.\n\n" +
        "• Run Payroll Again will be disabled\n" +
        "• The register will be locked automatically\n\n" +
        "Proceed?",
    );

    if (!ok) return;

    setIsDisbursed(true);
    setIsLocked(true);

    document.getElementById("runPayrollBtn").style.display = "none";
    document.getElementById("markDisbursedBtn").style.display = "none";

    const badge = document.getElementById("disbursedBadge");
    if (badge) badge.style.display = "inline-flex";

    const periodStatus = document.getElementById("periodStatus");
    if (periodStatus) {
      periodStatus.innerHTML =
        '<i className="fa-solid fa-circle-check"></i> Disbursed';
      periodStatus.style.background = "#d1fae5";
      periodStatus.style.borderColor = "#6ee7b7";
      periodStatus.style.color = "#065f46";
    }

    // Show lock banner
    const lockBanner = document.getElementById("lockBanner");
    if (lockBanner) {
      lockBanner.style.display = "flex";
      lockBanner.innerHTML = `
        <i className="fa-solid fa-circle-check" style="color:var(--success)"></i>
        <strong>Payroll Disbursed &amp; Locked — February 2025</strong>
        Salaries have been paid out. This register is now read-only.
        <button className="btn btn-warning btn-sm" style="margin-left:auto" onclick="alert('Unlock request sent to Payroll Admin.')">
          <i className="fa-solid fa-unlock"></i> Request Unlock
        </button>`;
      lockBanner.style.background = "#f0fdf4";
      lockBanner.style.borderColor = "#bbf7d0";
      lockBanner.style.color = "#166534";
    }
  };

  const confirmRerun = () => {
    if (isDisbursed) {
      alert(
        "Payroll has already been disbursed for this period. Running payroll again after disbursement is not allowed.\n\nTo make corrections, request an unlock from the Payroll Admin.",
      );
      return;
    }
    const ok = window.confirm(
      "⚠️ Run Payroll Again — February 2025\n\n" +
        "This will re-run all 9 payroll steps and may override manually entered values for this month.\n\n" +
        "Do NOT run payroll again after salaries have been disbursed.\n\n" +
        "Are you sure you want to continue?",
    );
    if (ok) {
      alert(
        "Redirecting to Run Payroll... (In real app, navigate to run-payroll page)",
      );
      // window.location = 'Run-Payroll';
    }
  };

  const toggleLock = () => {
    if (isLocked) {
      alert("Requires Payroll Admin permission to unlock.");
      return;
    }
    const newLocked = !isLocked;
    setIsLocked(newLocked);

    const lockBanner = document.getElementById("lockBanner");
    if (lockBanner) lockBanner.style.display = newLocked ? "flex" : "none";

    const lockIcon = document.getElementById("lockIcon");
    const lockTxt = document.getElementById("lockTxt");
    if (lockIcon)
      lockIcon.className = newLocked
        ? "fa-solid fa-lock"
        : "fa-solid fa-lock-open";
    if (lockTxt) lockTxt.textContent = newLocked ? "Locked" : "Lock Month";
  };

  const checkLock = (value) => {
    const lockedMonths = ["dec2024", "nov2024"];
    const newLocked = lockedMonths.some((m) => value.includes(m));
    setIsLocked(newLocked);

    const lockBanner = document.getElementById("lockBanner");
    if (lockBanner) lockBanner.style.display = newLocked ? "flex" : "none";
  };

  const openProcessSummary = () => {
    setShowProcessSummery(true);
  };

  const closeProcessSummary = () => {
    setShowProcessSummery(false);
  };

  return (
    <div className="container-fluid">
      <div>
        <header className="salaryregis-topbar">
          <div className="topbar-actions">
            <button
              className="btn btn-og-secondary btn-sm"
              onClick={openProcessSummary}
            >
              <i className="fa-solid fa-circle-info"></i> Process Summary
            </button>
            <button
              className="btn btn-og-secondary btn-sm"
              onClick={() =>
                alert("Generating Excel…\nFile: Payroll_Feb_2025.xlsx")
              }
            >
              <i className="fa-solid fa-file-excel"></i> Export Excel
            </button>
            <button
              className="btn btn-og-secondary btn-sm"
              onClick={() =>
                alert(
                  "Generating bank transfer file (NEFT format)…\nFile: Bank_Transfer_Feb_2025.txt",
                )
              }
            >
              <i className="fa-solid fa-building-columns"></i> Bank Format
            </button>
            <button
              className="btn btn-success btn-sm"
              id="markDisbursedBtn"
              onClick={markDisbursed}
            >
              <i className="fa-solid fa-circle-check"></i> Mark Disbursed
            </button>
            <span
              id="disbursedBadge"
              style={{
                display: isDisbursed ? "inline-flex" : "none",
                alignItems: "center",
                gap: "5px",
                background: "#d1fae5",
                color: "#065f46",
                padding: "5px 12px",
                borderRadius: "6px",
                fontWeight: 700,
                fontSize: "12px",
              }}
            >
              <i className="fa-solid fa-circle-check"></i> Disbursed
            </span>
            <Link className="btn btn-brand btn-sm" to="/Payroll/Run-Payroll">
              <i className="fa-solid fa-rotate"></i> Run Payroll Again
            </Link>
          </div>
        </header>

        <div className="page-header">
          <div>
            <h1 className="page-title">Salary Register</h1>
            <p className="page-subtitle">
              Complete salary statement — all components, double-click earned
              cells to override
            </p>
          </div>
          <div className="page-header-right">
            <div className="month-selector">
              <label className="form-label mb-0">Period</label>
              <select
                className="form-select"
                value={selectedMonth}
                onChange={(e) => {
                  setSelectedMonth(e.target.value);
                  checkLock(e.target.value);
                }}
              >
                {masterMonthList.map((m) => (
                  <option
                    key={m.Id}
                    value={m.Id}
                    selected={m.Name === "feb2025"}
                  >
                    {m.Name}{" "}
                    {["dec2024", "nov2024"].includes(m.Value) ? "🔒" : ""}
                  </option>
                ))}
                {/* // <option value="apr2025">April 2025</option>
                // <option value="mar2025">March 2025</option>
                // <option value="feb2025" selected>
                //   February 2025
                // </option>
                // <option value="jan2025">January 2025</option>
                // <option value="dec2024">December 2024 🔒</option>
                // <option value="nov2024">November 2024 🔒</option> */}
              </select>
            </div>
            <span
              id="periodStatus"
              style={{
                display: "inline-flex",
                alignItems: "center",
                gap: "6px",
                background: "#fef3c7",
                border: "1px solid #fcd34d",
                color: "#92400e",
                padding: "4px 12px",
                borderRadius: "6px",
                fontSize: "12px",
                fontWeight: 700,
              }}
            >
              <i className="fa-regular fa-clock"></i> Pending
            </span>
            <button
              className="btn btn-light btn-sm"
              onClick={toggleLock}
              id="lockBtn"
            >
              <i className="fa-solid fa-lock-open" id="lockIcon"></i>
              <span id="lockTxt">Lock Month</span>
            </button>
          </div>
        </div>

        {/* Lock Banner */}
        <div
          className="lock-banner"
          id="lockBanner"
          style={{ display: isLocked ? "flex" : "none" }}
        >
          <i className="fa-solid fa-lock"></i>
          <strong>This period is locked.</strong> Read-only. Contact Payroll
          Admin to unlock.
          <button
            className="btn btn-warning btn-sm"
            style={{ marginLeft: "auto" }}
            onClick={() => alert("Unlock request sent.")}
          >
            <i className="fa-solid fa-unlock"></i> Request Unlock
          </button>
        </div>

        {/* Summary Cards */}
        <div
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(5, 1fr)",
            gap: "8px",
            marginBottom: "10px",
          }}
        >
          <div
            style={{
              background: "#fff",
              border: "1px solid var(--border)",
              borderRadius: "8px",
              padding: "8px 12px",
              borderLeft: "3px solid var(--brand)",
            }}
          >
            <div
              style={{
                fontSize: "10px",
                fontWeight: 700,
                color: "var(--text-muted)",
                textTransform: "uppercase",
                letterSpacing: ".4px",
              }}
            >
              In Payroll Cycle
            </div>
            <div
              style={{
                fontSize: "20px",
                fontWeight: 800,
                color: "var(--text-dark)",
                lineHeight: "1.2",
              }}
              id="sc-emp"
            >
              48
            </div>
          </div>
          <div
            style={{
              background: "#fff",
              border: "1px solid var(--border)",
              borderRadius: "8px",
              padding: "8px 12px",
              borderLeft: "3px solid #3b82f6",
            }}
          >
            <div
              style={{
                fontSize: "10px",
                fontWeight: 700,
                color: "var(--text-muted)",
                textTransform: "uppercase",
                letterSpacing: ".4px",
              }}
            >
              By Account
            </div>
            <div
              style={{
                fontSize: "20px",
                fontWeight: 800,
                color: "#1e40af",
                lineHeight: "1.2",
              }}
              id="sc-account"
            >
              —
            </div>
          </div>
          <div
            style={{
              background: "#fff",
              border: "1px solid var(--border)",
              borderRadius: "8px",
              padding: "8px 12px",
              borderLeft: "3px solid #8b5cf6",
            }}
          >
            <div
              style={{
                fontSize: "10px",
                fontWeight: 700,
                color: "var(--text-muted)",
                textTransform: "uppercase",
                letterSpacing: ".4px",
              }}
            >
              By Cash
            </div>
            <div
              style={{
                fontSize: "20px",
                fontWeight: 800,
                color: "#6d28d9",
                lineHeight: "1.2",
              }}
              id="sc-cash"
            >
              —
            </div>
          </div>
          <div
            style={{
              background: "#fff",
              border: "1px solid var(--border)",
              borderRadius: "8px",
              padding: "8px 12px",
              borderLeft: "3px solid #6b7280",
            }}
          >
            <div
              style={{
                fontSize: "10px",
                fontWeight: 700,
                color: "var(--text-muted)",
                textTransform: "uppercase",
                letterSpacing: ".4px",
              }}
            >
              Pay Later
            </div>
            <div
              style={{
                fontSize: "20px",
                fontWeight: 800,
                color: "#374151",
                lineHeight: "1.2",
              }}
              id="sc-later"
            >
              —
            </div>
          </div>
          <div
            style={{
              background: "#fff",
              border: "1px solid var(--border)",
              borderRadius: "8px",
              padding: "8px 12px",
              borderLeft: "3px solid var(--success)",
            }}
          >
            <div
              style={{
                fontSize: "10px",
                fontWeight: 700,
                color: "var(--text-muted)",
                textTransform: "uppercase",
                letterSpacing: ".4px",
              }}
            >
              Status
            </div>
            <div style={{ marginTop: "3px" }} id="sc-status">
              <span className="badge badge-pending">
                <i className="fa-regular fa-clock"></i> Pending
              </span>
            </div>
          </div>
        </div>

        <div
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(5, 1fr)",
            gap: "8px",
            marginBottom: "14px",
          }}
        >
          <div
            style={{
              background: "#fff",
              border: "1px solid var(--border)",
              borderRadius: "8px",
              padding: "8px 12px",
              borderLeft: "3px solid #10b981",
            }}
          >
            <div
              style={{
                fontSize: "10px",
                fontWeight: 700,
                color: "var(--text-muted)",
                textTransform: "uppercase",
                letterSpacing: ".4px",
              }}
            >
              Net Payable
            </div>
            <div
              style={{
                fontSize: "15px",
                fontWeight: 800,
                color: "#065f46",
                lineHeight: "1.3",
              }}
              id="sc-net"
            >
              —
            </div>
          </div>
          <div
            style={{
              background: "#fff",
              border: "1px solid var(--border)",
              borderRadius: "8px",
              padding: "8px 12px",
              borderLeft: "3px solid #3b82f6",
            }}
          >
            <div
              style={{
                fontSize: "10px",
                fontWeight: 700,
                color: "var(--text-muted)",
                textTransform: "uppercase",
                letterSpacing: ".4px",
              }}
            >
              PF (EE+ER)
            </div>
            <div
              style={{
                fontSize: "15px",
                fontWeight: 800,
                color: "#1e40af",
                lineHeight: "1.3",
              }}
              id="sc-pf"
            >
              —
            </div>
          </div>
          <div
            style={{
              background: "#fff",
              border: "1px solid var(--border)",
              borderRadius: "8px",
              padding: "8px 12px",
              borderLeft: "3px solid #06b6d4",
            }}
          >
            <div
              style={{
                fontSize: "10px",
                fontWeight: 700,
                color: "var(--text-muted)",
                textTransform: "uppercase",
                letterSpacing: ".4px",
              }}
            >
              ESIC (EE+ER)
            </div>
            <div
              style={{
                fontSize: "15px",
                fontWeight: 800,
                color: "#0e7490",
                lineHeight: "1.3",
              }}
              id="sc-esic"
            >
              —
            </div>
          </div>
          <div
            style={{
              background: "#fff",
              border: "1px solid var(--border)",
              borderRadius: "8px",
              padding: "8px 12px",
              borderLeft: "3px solid #f59e0b",
            }}
          >
            <div
              style={{
                fontSize: "10px",
                fontWeight: 700,
                color: "var(--text-muted)",
                textTransform: "uppercase",
                letterSpacing: ".4px",
              }}
            >
              TDS
            </div>
            <div
              style={{
                fontSize: "15px",
                fontWeight: 800,
                color: "#92400e",
                lineHeight: "1.3",
              }}
              id="sc-tds"
            >
              —
            </div>
          </div>
          <div
            style={{
              background: "#fff",
              border: "1px solid var(--border)",
              borderRadius: "8px",
              padding: "8px 12px",
              borderLeft: "3px solid #ec4899",
            }}
          >
            <div
              style={{
                fontSize: "10px",
                fontWeight: 700,
                color: "var(--text-muted)",
                textTransform: "uppercase",
                letterSpacing: ".4px",
              }}
            >
              Others (Food Cpn)
            </div>
            <div
              style={{
                fontSize: "15px",
                fontWeight: 800,
                color: "#9d174d",
                lineHeight: "1.3",
              }}
              id="sc-food"
            >
              —
            </div>
          </div>
        </div>

        {/* Column Toggles */}
        <div className="filter-bar">
          <div style={{ width: "100%" }}>
            <p
              style={{
                fontSize: "11.5px",
                fontWeight: 700,
                color: "var(--text-mid)",
                margin: "0 0 6px",
              }}
            >
              <i className="fa-solid fa-table-columns me-1 text-brand"></i>
              Column Groups
            </p>
            <div style={{ display: "flex", flexWrap: "wrap", gap: "6px" }}>
              {[
                {
                  grp: "grp-attendance",
                  icon: "fa-calendar-check",
                  label: "Attendance",
                },
                { grp: "grp-ctc", icon: "fa-chart-line", label: "CTC" },
                {
                  grp: "grp-earnings",
                  icon: "fa-indian-rupee-sign",
                  label: "Earnings",
                },
                {
                  grp: "grp-reimb",
                  icon: "fa-receipt",
                  label: "Reimbursements",
                },
                { grp: "grp-earned", icon: "fa-wallet", label: "Earned Gross" },
                {
                  grp: "grp-additions",
                  icon: "fa-plus-circle",
                  label: "Additions",
                },
                { grp: "grp-stat", icon: "fa-shield", label: "Statutory Ded." },
                {
                  grp: "grp-otherded",
                  icon: "fa-minus-circle",
                  label: "Other Ded.",
                },
                {
                  grp: "grp-employer",
                  icon: "fa-building",
                  label: "Employer Contribs",
                },
                {
                  grp: "grp-net",
                  icon: "fa-money-bill-transfer",
                  label: "Net Pay",
                },
              ].map((item) => (
                <span
                  key={item.grp}
                  className="col-chip active"
                  data-grp={item.grp}
                  onClick={toggleGrp}
                >
                  <i className={`fa-solid ${item.icon}`}></i> {item.label}
                </span>
              ))}
            </div>
          </div>
        </div>

        {/* Table Card */}
        <div className="card" style={{ overflow: "hidden" }}>
          <div className="toolbar">
            <input
              type="text"
              className="form-control"
              placeholder="Search employee…"
              style={{ width: "200px" }}
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
            />
            <div className="toolbar-sep"></div>
            <select
              className="form-select"
              style={{ width: "140px" }}
              value={deptFilter}
              onChange={(e) => setDeptFilter(e.target.value)}
            >
              <option value="">All Departments</option>
              <option>Engineering</option>
              <option>Product</option>
              <option>Design</option>
              <option>Operations</option>
              <option>HR</option>
              <option>Finance</option>
            </select>
            <select
              className="form-select"
              style={{ width: "120px" }}
              value={statusFilter}
              onChange={(e) => setStatusFilter(e.target.value)}
            >
              <option value="">All Status</option>
              <option value="pending">Pending</option>
              <option value="paid">Paid</option>
            </select>
            <div className="toolbar-spacer"></div>
            <span
              style={{ fontSize: "12px", color: "var(--text-muted)" }}
              id="rowCount"
            >
              48 employees
            </span>
          </div>

          <div className="salary-table-wrap">
            <table className="salary-tbl" ref={tableRef}>
              <thead>
                <tr>
                  <th
                    colSpan="4"
                    className="col-freeze-4 text-left group-header"
                    style={{ left: 0, minWidth: "330px" }}
                  >
                    Employee
                  </th>
                  <th colSpan="3" className="grp-attendance group-header">
                    Attendance
                  </th>
                  <th colSpan="2" className="grp-ctc group-header group-sep">
                    CTC
                  </th>
                  <th
                    colSpan="6"
                    className="grp-earnings group-header group-sep"
                  >
                    Earnings (Structure)
                  </th>
                  <th colSpan="8" className="grp-reimb group-header group-sep">
                    Reimbursements (Structure)
                  </th>
                  <th colSpan="7" className="grp-earned group-header group-sep">
                    Earned Gross
                  </th>

                  <th colSpan="8" className="grp-reimb group-header group-sep">
                   Earned Reimbursements (Structure)
                  </th>
                  <th
                    colSpan="5"
                    className="grp-additions group-header group-sep"
                  >
                    Additions
                  </th>
                  <th colSpan="4" className="grp-stat group-header group-sep">
                    Statutory Deductions
                  </th>
                  <th
                    colSpan="4"
                    className="grp-otherded group-header group-sep"
                  >
                    Other Deductions
                  </th>
                  <th
                    colSpan="3"
                    className="grp-employer group-header group-sep"
                  >
                    Employer Contribs
                  </th>
                  <th colSpan="3" className="grp-net group-header group-sep">
                    Net Pay
                  </th>
                  <th className="group-header" style={{ minWidth: "60px" }}>
                    Action
                  </th>
                </tr>
                <tr>
                  <th
                    className="col-freeze text-left"
                    style={{ left: 0, minWidth: "36px", top: "26px" }}
                  >
                    #
                  </th>
                  <th
                    className="col-freeze-2 text-left"
                    style={{ left: "36px", minWidth: "68px", top: "26px" }}
                  >
                    Emp ID
                  </th>
                  <th
                    className="col-freeze-3 text-left"
                    style={{ left: "104px", minWidth: "150px", top: "26px" }}
                  >
                    Name
                  </th>
                  <th
                    className="col-freeze-4 text-left"
                    style={{ left: "254px", minWidth: "130px", top: "26px" }}
                  >
                    Dept / Role
                  </th>
                  <th className="grp-attendance" style={{ top: "26px" }}>
                    Days
                  </th>
                  <th className="grp-attendance" style={{ top: "26px" }}>
                    AWD
                  </th>
                  <th className="grp-attendance" style={{ top: "26px" }}>
                    LOP
                  </th>
                  <th className="grp-ctc group-sep" style={{ top: "26px" }}>
                    Monthly CTC
                  </th>
                  <th className="grp-ctc" style={{ top: "26px" }}>
                    Annual CTC
                  </th>
                  <th
                    className="grp-earnings group-sep"
                    style={{ top: "26px" }}
                  >
                    Basic
                  </th>
                  <th className="grp-earnings" style={{ top: "26px" }}>
                    HRA
                  </th>
                  <th className="grp-earnings" style={{ top: "26px" }}>
                    Sp. Allow.
                  </th>
                  <th className="grp-earnings" style={{ top: "26px" }}>
                    Bonus
                  </th>
                  <th className="grp-earnings" style={{ top: "26px" }}>
                    Med. Ins.
                  </th>
                  <th
                    className="grp-earnings"
                    style={{ top: "26px", fontWeight: 800 }}
                  >
                    Gross
                  </th>
                  <th className="grp-reimb group-sep" style={{ top: "26px" }}>
                    Meal
                  </th>
                  <th className="grp-reimb" style={{ top: "26px" }}>
                    Fuel
                  </th>
                  <th className="grp-reimb" style={{ top: "26px" }}>
                    Driver
                  </th>
                  <th className="grp-reimb" style={{ top: "26px" }}>
                    Mobile
                  </th>
                  <th className="grp-reimb" style={{ top: "26px" }}>
                    Internet
                  </th>
                  <th className="grp-reimb" style={{ top: "26px" }}>
                    Books&amp;Edu
                  </th>
                  <th className="grp-reimb" style={{ top: "26px" }}>
                    E.Children&amp;Edu
                  </th>
                  <th className="grp-reimb" style={{ top: "26px" }}>
                    LTA
                  </th>
                  <th className="grp-earned group-sep" style={{ top: "26px" }}>
                    E.Basic
                  </th>
                  <th className="grp-earned" style={{ top: "26px" }}>
                    E.HRA
                  </th>
                  <th className="grp-earned" style={{ top: "26px" }}>
                    E.Sp.Allow
                  </th>
                  <th className="grp-earned" style={{ top: "26px" }}>
                    E.Bonus
                  </th>
                  <th className="grp-earned" style={{ top: "26px" }}>
                    E.Reimb.
                  </th>
                  <th className="grp-earned" style={{ top: "26px" }}>
                    OT
                  </th>
                  <th
                    className="grp-earned"
                    style={{ top: "26px", fontWeight: 800 }}
                  >
                    Total Gross
                  </th>

                   <th className="grp-reimb group-sep" style={{ top: "26px" }}>
                    E.Meal
                  </th>
                  <th className="grp-reimb" style={{ top: "26px" }}>
                    E.Fuel
                  </th>
                  <th className="grp-reimb" style={{ top: "26px" }}>
                    E.Driver
                  </th>
                  <th className="grp-reimb" style={{ top: "26px" }}>
                    E.Mobile
                  </th>
                  <th className="grp-reimb" style={{ top: "26px" }}>
                    E.Internet
                  </th>
                  <th className="grp-reimb" style={{ top: "26px" }}>
                    E.Books&amp;Edu
                  </th>
                  <th className="grp-reimb" style={{ top: "26px" }}>
                    E.Children&amp;Edu
                  </th>
                  <th className="grp-reimb" style={{ top: "26px" }}>
                    E.LTA
                  </th>
                  <th
                    className="grp-additions group-sep"
                    style={{ top: "26px" }}
                  >
                    Arrear
                  </th>
                  <th className="grp-additions" style={{ top: "26px" }}>
                    Incentive
                  </th>
                  <th className="grp-additions" style={{ top: "26px" }}>
                    Variable
                  </th>
                  <th className="grp-additions" style={{ top: "26px" }}>
                    Retention
                  </th>
                  <th
                    className="grp-additions"
                    style={{ top: "26px", fontWeight: 800 }}
                  >
                    Total Add.
                  </th>
                  <th className="grp-stat group-sep" style={{ top: "26px" }}>
                    PF (EE)
                  </th>
                  <th className="grp-stat" style={{ top: "26px" }}>
                    ESIC (EE)
                  </th>
                  <th className="grp-stat" style={{ top: "26px" }}>
                    Prof.Tax
                  </th>
                  <th className="grp-stat" style={{ top: "26px" }}>
                    TDS
                  </th>
                  <th
                    className="grp-otherded group-sep"
                    style={{ top: "26px" }}
                  >
                    Advance
                  </th>
                  <th className="grp-otherded" style={{ top: "26px" }}>
                    Loan Ded.
                  </th>
                  <th className="grp-otherded" style={{ top: "26px" }}>
                    Food Cpn
                  </th>
                  <th
                    className="grp-otherded"
                    style={{ top: "26px", fontWeight: 800 }}
                  >
                    Total Ded.
                  </th>
                  <th
                    className="grp-employer group-sep"
                    style={{ top: "26px" }}
                  >
                    PF (ER)
                  </th>
                  <th className="grp-employer" style={{ top: "26px" }}>
                    ESIC (ER)
                  </th>
                  <th className="grp-employer" style={{ top: "26px" }}>
                    Gratuity
                  </th>
                  <th
                    className="grp-net group-sep"
                    style={{
                      top: "26px",
                      fontWeight: 800,
                      color: "var(--brand)",
                    }}
                  >
                    Net Payable
                  </th>
                  <th className="grp-net" style={{ top: "26px" }}>
                    Pay Mode
                  </th>
                  <th className="grp-net" style={{ top: "26px" }}>
                    Tax Regime
                  </th>
                  <th
                    style={{
                      top: "26px",
                      textAlign: "center",
                      minWidth: "60px",
                    }}
                  >
                    Slip
                  </th>
                </tr>
              </thead>
              <tbody id="salaryBody">
                {SalaryRegisterList?.map((e, i) => (
                  <tr
                    key={e.eid}
                    data-name={e.EmployeeName.toLowerCase()}
                    data-dept={e.CurrentDesignation}
                    // data-status={e.status}
                  >
                    <td className="col-freeze text-left" style={{ left: 0 }}>
                      {i + 1}
                    </td>
                    <td
                      className="col-freeze-2 text-left"
                      style={{ left: "36px" }}
                    >
                      <code
                        style={{ fontSize: "10.5px", color: "var(--brand)" }}
                      >
                        {e?.EmpId}
                      </code>
                    </td>
                    <td
                      className="col-freeze-3 text-left"
                      style={{ left: "104px" }}
                    >
                      <span style={{ fontWeight: 600 }}>{e?.EmployeeName}</span>
                      {e.ovr && (
                        <span
                          className="override-tag ms-1"
                          title="Has overrides"
                        >
                          <i className="fa-solid fa-pen-line"></i>
                        </span>
                      )}
                    </td>
                    <td
                      className="col-freeze-4 text-left"
                      style={{ left: "254px" }}
                    >
                      <span
                        style={{
                          fontSize: "10.5px",
                          color: "var(--text-muted)",
                        }}
                      >
                        {e?.CurrentDesignation}
                      </span>
                      <br />
                      <span style={{ fontSize: "11px" }}>{e?.role}</span>
                    </td>
                    <td className="grp-attendance">{e?.Days}</td>
                    <td
                      className="grp-attendance num"
                      style={{ color: e.lop > 0 ? "var(--danger)" : "inherit" }}
                    >
                      {e.O_WorkingDays}
                    </td>
                    <td
                      className="grp-attendance num"
                      style={{
                        color:
                          e.lop > 0 ? "var(--danger)" : "var(--text-muted)",
                      }}
                    >
                      {Math.floor(e?.Days - e?.O_WorkingDays)  || <span className="zero">0</span>}
                    </td>
                    <td className="grp-ctc group-sep num">{rup(e.O_MonthlyCTC)}</td>
                    <td className="grp-ctc num">{rup(e.O_CTC)}</td>
                    <td className="grp-earnings group-sep num">
                      {rup(e.O_Basic)}
                    </td>
                    <td className="grp-earnings num">{rup(e.O_HRA)}</td>
                    <td className="grp-earnings num">{rup(e.O_SpecialAllowance)}</td>
                    <td className="grp-earnings num">{rup(e.bonus)}</td>
                    <td className="grp-earnings num zero">
                      {rup(e?.O_MedicalInsurance)}
                    </td>
                    <td className="grp-earnings num fw-bold">{rup(e.O_Gross)}</td>
                    <td className="grp-reimb group-sep num">
                      {rup(e?.O_MealCoupon)}
                    </td>
                    <td className="grp-reimb num zero">
                      {rup(e?.O_FuelReimbursement)}
                    </td>
                    <td className="grp-reimb num zero">
                      {rup(e?.O_DriverReimbursement)}
                    </td>
                    <td className="grp-reimb num">
                      {rup(e?.O_MobileReimbursement)}
                    </td>
                    <td className="grp-reimb num">
                      {rup(e?.O_InternetReimbursement)}
                    </td>
                    <td className="grp-reimb num zero">
                      {rup(e?.O_BooksandPeriodcals)}
                    </td>
                     <td className="grp-reimb num zero">
                      {rup(e?.O_ChilldrenEducation)}
                    </td>
                    <td className="grp-reimb num zero">{rup(e?.O_LTA)}</td>
                    <td
                      className="grp-earned group-sep num editable-cell"
                      title="Dbl-click to override"
                      onDoubleClick={() =>
                        openEdit(null, e.eid, "Earned Basic", e.E_Basic)
                      }
                    >
                      {rup(e.E_Basic)}
                    </td>
                    <td
                      className="grp-earned num editable-cell"
                      onDoubleClick={() =>
                        openEdit(null, e.eid, "Earned HRA", e.E_HRA)
                      }
                    >
                      {rup(e.E_HRA)}
                    </td>
                    <td
                      className="grp-earned num editable-cell"
                      onDoubleClick={() =>
                        openEdit(null, e.eid, "Earned Sp.Allow", e.spec)
                      }
                    >
                      {rup(e.spec)}
                    </td>
                    <td className="grp-earned num">{rup(e.E_StatutoryBonus)}</td>
                    <td className="grp-earned num">{rup(e.e_reimb)}</td>
                    <td className="grp-earned num">
                      {e.ot ? rup(e.ot) : <span className="zero">—</span>}
                    </td>
                    <td
                      className="grp-earned num fw-bold"
                      style={{ color: "var(--text-dark)" }}
                    >
                      {rup(e.tgross)}
                    </td>

                     <td className="grp-reimb group-sep num">
                      {rup(e?.E_MealCoupon)}
                    </td>
                    <td className="grp-reimb num zero">
                      {rup(e?.E_FuelReimbursement)}
                    </td>
                    <td className="grp-reimb num zero">
                      {rup(e?.E_DriverReimbursement)}
                    </td>
                    <td className="grp-reimb num">
                      {rup(e?.E_MobileReimbursement)}
                    </td>
                    <td className="grp-reimb num">
                      {rup(e?.E_InternetReimbursement)}
                    </td>
                    <td className="grp-reimb num zero">
                      {rup(e?.E_BooksandPeriodcals)}
                    </td>
                     <td className="grp-reimb num zero">
                      {rup(e?.E_ChilldrenEducation)}
                    </td>
                    <td className="grp-reimb num zero">{rup(e?.LTA)}</td>

                    <td
                      className="grp-additions group-sep num editable-cell"
                      onDoubleClick={() =>
                        openEdit(null, e.eid, "Arrear", e.arrear)
                      }
                    >
                      {rup(e.arrear)}
                    </td>
                    <td
                      className="grp-additions num editable-cell"
                      onDoubleClick={() =>
                        openEdit(null, e.eid, "Incentive", e.incent)
                      }
                    >
                      {rup(e.incent)}
                    </td>
                    <td
                      className="grp-additions num editable-cell"
                      onDoubleClick={() =>
                        openEdit(null, e.eid, "Variable", e.varbl)
                      }
                    >
                      {rup(e.O_Variable)}
                    </td>
                    <td className="grp-additions num">{rup(e.O_RetentionBonus)}</td>
                    <td className="grp-additions num fw-bold">{rup(e.tadd)}</td>
                    <td className="grp-stat group-sep num">
                      {rup(e.E_ProvidentFundEmployee)}
                    </td>
                    <td className="grp-stat num">
                      {e.E_ESICEmployee ? (
                        rup(e.E_ESICEmployee)
                      ) : (
                        <span className="zero">—</span>
                      )}
                    </td>
                    <td className="grp-stat num">{rup(e.pt)}</td>
                    <td
                      className="grp-stat num editable-cell"
                      onDoubleClick={() => openEdit(null, e.eid, "TDS", e.tds)}
                    >
                      {rup(e.tds)}
                    </td>
                    <td className="grp-otherded group-sep num">{rup(e.adv)}</td>
                    <td className="grp-otherded num">{rup(e.loan)}</td>
                    <td className="grp-otherded num">{rup(e.food)}</td>
                    <td
                      className="grp-otherded num fw-bold"
                      style={{ color: "var(--danger)" }}
                    >
                      {rup(e.tded)}
                    </td>
                    <td className="grp-employer group-sep num">
                      {rup(e?.E_ProvidentFundEmployer)}
                    </td>
                    <td className="grp-employer num">
                      {e.E_ESICEmployer ? (
                        rup(e.E_ESICEmployer)
                      ) : (
                        <span className="zero">—</span>
                      )}
                    </td>
                    <td className="grp-employer num">{rup(e.grat)}</td>
                    <td
                      className="grp-net group-sep num fw-bold text-brand"
                      style={{ fontSize: "12.5px" }}
                    >
                      {rup(e.net)}
                    </td>
                    <td
                      className="grp-net text-left"
                      style={{ minWidth: "140px" }}
                    >
                      <div style={{ display: "flex", gap: "4px" }}>
                        <span
                          className={`pay-mode-btn account ${e.mode === "account" ? "sel" : ""}`}
                          onClick={(ev) => setMode(ev, "account", e.eid)}
                        >
                          Acct
                        </span>
                        <span
                          className={`pay-mode-btn cash ${e.mode === "cash" ? "sel" : ""}`}
                          onClick={(ev) => setMode(ev, "cash", e.eid)}
                        >
                          Cash
                        </span>
                        <span
                          className={`pay-mode-btn later ${e.mode === "later" ? "sel" : ""}`}
                          onClick={(ev) => setMode(ev, "later", e.eid)}
                        >
                          Later
                        </span>
                      </div>
                    </td>
                    <td className="grp-net">
                      <span
                        className={`badge ${e.TaxRegime === "New" ? "badge-account" : "badge-cash"}`}
                      >
                        {e.O_TaxRegime}
                      </span>
                    </td>
                    <td style={{ textAlign: "center" }}>
                      <Link
                        to={`/Payroll/Salary-Slip/${e?.EmpId}/${selectedMonth}`}
                        title="View Salary Slip"
                        style={{
                          display: "inline-flex",
                          alignItems: "center",
                          justifyContent: "center",
                          width: "28px",
                          height: "28px",
                          borderRadius: "6px",
                          background: "#f1f3f5",
                          border: "1px solid var(--border)",
                          color: "var(--text-mid)",
                          textDecoration: "none",
                          transition: ".15s",
                        }}
                      >
                        <i
                          className="fa-regular fa-file-lines"
                          style={{ fontSize: "12px" }}
                        ></i>
                      </Link>
                    </td>
                  </tr>
                ))}
              </tbody>
              <tfoot>
                <tr className="totals-row" id="totalsRow">
                  <td className="col-freeze" style={{ left: 0 }}></td>
                  <td className="col-freeze-2" style={{ left: "36px" }}></td>
                  <td
                    className="col-freeze-3 text-left fw-bold"
                    style={{ left: "104px" }}
                  >
                    TOTALS
                  </td>
                  <td className="col-freeze-4" style={{ left: "254px" }}></td>
                  <td className="grp-attendance">28</td>
                  <td className="grp-attendance fw-bold" id="t-awd">
                    —
                  </td>
                  <td className="grp-attendance" id="t-lop">
                    —
                  </td>
                  <td className="grp-ctc group-sep fw-bold" id="t-mctc">
                    —
                  </td>
                  <td className="grp-ctc" id="t-actc">
                    —
                  </td>
                  <td className="grp-earnings group-sep fw-bold" id="t-basic">
                    —
                  </td>
                  <td className="grp-earnings fw-bold" id="t-hra">
                    —
                  </td>
                  <td className="grp-earnings fw-bold" id="t-spec">
                    —
                  </td>
                  <td className="grp-earnings" id="t-bonus">
                    —
                  </td>
                  <td className="grp-earnings" id="t-mi">
                    —
                  </td>
                  <td className="grp-earnings fw-bold" id="t-gross-s">
                    —
                  </td>
                  <td className="grp-reimb group-sep" id="t-meal">
                    —
                  </td>
                  <td className="grp-reimb" id="t-fuel">
                    —
                  </td>
                  <td className="grp-reimb" id="t-driver">
                    —
                  </td>
                  <td className="grp-reimb" id="t-mobile">
                    —
                  </td>
                  <td className="grp-reimb" id="t-internet">
                    —
                  </td>
                  <td className="grp-reimb" id="t-books">
                    —
                  </td>
                  <td className="grp-reimb" id="t-lta">
                    —
                  </td>
                  <td className="grp-earned group-sep fw-bold" id="t-e-basic">
                    —
                  </td>
                  <td className="grp-earned fw-bold" id="t-e-hra">
                    —
                  </td>
                  <td className="grp-earned fw-bold" id="t-e-spec">
                    —
                  </td>
                  <td className="grp-earned" id="t-e-bonus">
                    —
                  </td>
                  <td className="grp-earned" id="t-e-reimb">
                    —
                  </td>
                  <td className="grp-earned" id="t-ot">
                    —
                  </td>
                  <td className="grp-earned fw-bold" id="t-tgross">
                    —
                  </td>
                  <td className="grp-additions group-sep" id="t-arrear">
                    —
                  </td>
                  <td className="grp-additions" id="t-incent">
                    —
                  </td>
                  <td className="grp-additions" id="t-variable">
                    —
                  </td>
                  <td className="grp-additions" id="t-retain">
                    —
                  </td>
                  <td className="grp-additions fw-bold" id="t-tadd">
                    —
                  </td>
                  <td className="grp-stat group-sep fw-bold" id="t-pf-ee">
                    —
                  </td>
                  <td className="grp-stat fw-bold" id="t-esic-ee">
                    —
                  </td>
                  <td className="grp-stat" id="t-pt">
                    —
                  </td>
                  <td className="grp-stat fw-bold" id="t-tds">
                    —
                  </td>
                  <td className="grp-otherded group-sep" id="t-adv">
                    —
                  </td>
                  <td className="grp-otherded" id="t-loan">
                    —
                  </td>
                  <td className="grp-otherded" id="t-food">
                    —
                  </td>
                  <td
                    className="grp-otherded fw-bold"
                    id="t-tded"
                    style={{ color: "var(--danger)" }}
                  >
                    —
                  </td>
                  <td className="grp-employer group-sep fw-bold" id="t-pf-er">
                    —
                  </td>
                  <td className="grp-employer fw-bold" id="t-esic-er">
                    —
                  </td>
                  <td className="grp-employer" id="t-grat">
                    —
                  </td>
                  <td
                    className="grp-net group-sep fw-bold text-brand"
                    id="t-net"
                    style={{ fontSize: "13px" }}
                  >
                    —
                  </td>
                  <td className="grp-net">—</td>
                  <td className="grp-net">—</td>
                  <td>—</td>
                </tr>
              </tfoot>
            </table>
          </div>
        </div>
      </div>

      {/* Edit Modal */}
      {editModal.show && (
        <div
          style={{
            position: "fixed",
            inset: 0,
            zIndex: 999,
            background: "rgba(0,0,0,0.45)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
          onClick={closeEdit}
        >
          <div
            style={{
              background: "#fff",
              borderRadius: "12px",
              padding: "24px",
              width: "440px",
            }}
            onClick={(e) => e.stopPropagation()}
          >
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: "10px",
                marginBottom: "14px",
              }}
            >
              <span
                style={{
                  width: "8px",
                  height: "8px",
                  borderRadius: "50%",
                  background: "var(--brand)",
                  display: "inline-block",
                }}
              ></span>
              <h6
                style={{ margin: 0, fontSize: "14px", fontWeight: 700 }}
                id="editTitle"
              >
                Override — {editModal.eid}: {editModal.field}
              </h6>
              <button
                style={{
                  marginLeft: "auto",
                  background: "none",
                  border: "none",
                  fontSize: "20px",
                  cursor: "pointer",
                  color: "#888",
                  lineHeight: 1,
                }}
                onClick={closeEdit}
              >
                ×
              </button>
            </div>

            <div
              className="alert alert-warning"
              style={{ marginBottom: "12px" }}
            >
              <i className="fa-solid fa-triangle-exclamation"></i> Override will
              be flagged for audit. Original value preserved.
            </div>

            <div style={{ marginBottom: "10px" }}>
              <label className="form-label" id="editField">
                {editModal.field}
              </label>
              <input
                type="number"
                className="form-control w-100"
                id="editInput"
                defaultValue={editModal.value}
              />
            </div>

            <div style={{ marginBottom: "14px" }}>
              <label className="form-label">Reason *</label>
              <select className="form-select w-100">
                <option value="">Select…</option>
                <option>Attendance adjustment</option>
                <option>Advance recovery</option>
                <option>Performance bonus</option>
                <option>Reimbursement correction</option>
                <option>TDS correction</option>
                <option>Other</option>
              </select>
            </div>

            <div
              style={{
                display: "flex",
                gap: "8px",
                justifyContent: "flex-end",
              }}
            >
              <button className="btn btn-light" onClick={closeEdit}>
                Cancel
              </button>
              <button className="btn btn-brand" onClick={applyEdit}>
                <i className="fa-solid fa-check"></i> Apply Override
              </button>
            </div>
          </div>
        </div>
      )}

      {/* <div style={{"background":"#fff","borderRadius":"12px","width":"520px","maxHeight":"80vh","overflowY":"auto","boxShadow":"0 20px 60px rgba(0,0,0,.2)"}} onclick="event.stopPropagation()">
    <div style={{"padding":"18px 22px","borderBottom":"1px solid var(--border)","display":"flex","alignItems":"center","gap":"10px"}}>
      <i className="fa-solid fa-circle-info text-brand" style="font-size:16px"></i>
      <h6 style={{"margin":"0","fontWeight":"700","fontSize":"14px"}}>Payroll Process Summary — February 2025</h6>
      <button style={{"marginLeft":"auto","background":"none","border":"none","fontSize":"20px","cursor":"pointer","color":"#888","lineHeight":"1"}} onclick="document.getElementById('processSummaryModal').style.display='none'">×</button>
    </div>
    <div style={{"padding":"20px 22px","display":"flex","flexDirection":"column","gap":"10px"}}>
      ${[
        {icon:'fa-users',color:'#EC4119',title:'Employees',body:'48 employees in payroll cycle · 0 excluded'},
        {icon:'fa-calendar-check',color:'#3b82f6',title:'Attendance & LOP',body:'Attendance synced · 8 employees with LOP · 14 total LOP days'},
        {icon:'fa-hand-holding-dollar',color:'#8b5cf6',title:'Loans & Advances',body:'5 loan records · Total deduction ₹31,000'},
        {icon:'fa-rotate-left',color:'#f59e0b',title:'Arrears',body:'3 arrear records · Total ₹38,500'},
        {icon:'fa-trophy',color:'#10b981',title:'Incentives',body:'4 incentive records · Total ₹68,000'},
        {icon:'fa-receipt',color:'#06b6d4',title:'Reimbursements',body:'9 claims · Total ₹25,400'},
        {icon:'fa-eye',color:'#64748b',title:'Review',body:'Reviewed · Payment modes set per employee'},
      ].map(s=>`
        <div style="display:flex;gap:12px;padding:10px 12px;background:#f8f9fa;border-radius:8px">
          <div style="width:32px;height:32px;border-radius:8px;background:${s.color}18;display:flex;align-items:center;justify-content:center;flex-shrink:0;color:${s.color}">
            <i className="fa-solid ${s.icon}" style="font-size:13px"></i>
          </div>
          <div>
            <div style="font-size:12.5px;font-weight:700;color:var(--text-dark)">${s.title}</div>
            <div style="font-size:11.5px;color:var(--text-muted);margin-top:2px">${s.body}</div>
          </div>
        </div>`).join('')}
    </div>
  </div> */}

      {showProcessSummery && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            background: "rgba(0,0,0,0.4)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 999,
          }}
          onClick={closeProcessSummary}
        >
          <div
            style={{
              background: "#fff",
              borderRadius: "12px",
              width: "520px",
              maxHeight: "80vh",
              overflowY: "auto",
              boxShadow: "0 20px 60px rgba(0,0,0,.2)",
            }}
            onClick={(e) => e.stopPropagation()}
          >
            {/* Header */}
            <div
              style={{
                padding: "18px 22px",
                borderBottom: "1px solid #eee",
                display: "flex",
                alignItems: "center",
                gap: "10px",
              }}
            >
              <i className="fa-solid fa-circle-info"></i>
              <h6 style={{ margin: 0, fontWeight: 700, fontSize: "14px" }}>
                Payroll Process Summary — February 2025
              </h6>

              <button
                onClick={closeProcessSummary}
                style={{
                  marginLeft: "auto",
                  background: "none",
                  border: "none",
                  fontSize: "20px",
                  cursor: "pointer",
                }}
              >
                ×
              </button>
            </div>

            {/* Body */}
            <div
              style={{
                padding: "20px 22px",
                display: "flex",
                flexDirection: "column",
                gap: "10px",
              }}
            >
              {[
                {
                  icon: "fa-users",
                  color: "#EC4119",
                  title: "Employees",
                  body: "48 employees in payroll cycle · 0 excluded",
                },
                {
                  icon: "fa-calendar-check",
                  color: "#3b82f6",
                  title: "Attendance & LOP",
                  body: "Attendance synced · 8 employees with LOP · 14 total LOP days",
                },
                {
                  icon: "fa-hand-holding-dollar",
                  color: "#8b5cf6",
                  title: "Loans & Advances",
                  body: "5 loan records · Total deduction ₹31,000",
                },
                {
                  icon: "fa-rotate-left",
                  color: "#f59e0b",
                  title: "Arrears",
                  body: "3 arrear records · Total ₹38,500",
                },
                {
                  icon: "fa-trophy",
                  color: "#10b981",
                  title: "Incentives",
                  body: "4 incentive records · Total ₹68,000",
                },
                {
                  icon: "fa-receipt",
                  color: "#06b6d4",
                  title: "Reimbursements",
                  body: "9 claims · Total ₹25,400",
                },
                {
                  icon: "fa-eye",
                  color: "#64748b",
                  title: "Review",
                  body: "Reviewed · Payment modes set per employee",
                },
              ].map((s, i) => (
                <div
                  key={i}
                  style={{
                    display: "flex",
                    gap: "12px",
                    padding: "10px 12px",
                    background: "#f8f9fa",
                    borderRadius: "8px",
                  }}
                >
                  <div
                    style={{
                      width: "32px",
                      height: "32px",
                      borderRadius: "8px",
                      background: `${s.color}18`,
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      color: s.color,
                    }}
                  >
                    <i
                      className={`fa-solid ${s.icon}`}
                      style={{ fontSize: "13px" }}
                    ></i>
                  </div>

                  <div>
                    <div style={{ fontSize: "12.5px", fontWeight: 700 }}>
                      {s.title}
                    </div>
                    <div style={{ fontSize: "11.5px", color: "#666" }}>
                      {s.body}
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default SalaryRegister;
